/**
 * 主题色单横向可缩放柱状图
 * @param unit 单位
 * @param name 图表名称
 * @param xData []x轴数据
 * @param yData []y轴数据
 */
import { dealBigNum } from "@/assets/js/utils";
export function setOption(paramObj) {
  let option = {
    grid: {
      left: "80px",
    },
    legend: {
      show: false,
      textStyle: {
        color: "#333",
        fontSize: 12,
      },
      right: "2%",
      top: "2%",
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params) {
        let result = params[0].name + "<br>";
        params.forEach(function (item) {
          result +=
            item.marker +
            " " +
            item.seriesName +
            " : " +
            dealBigNum(item.value) +
            paramObj.unit +
            "</br>";
        });
        return result;
      },
    },
    xAxis: {
      type: "value",
      axisLabel: {
        color: "#CBCBCB",
      },
      splitLine: {
        show: false,
      },
    },
    yAxis: {
      type: "category",
      data: paramObj.yData,
      axisTick: {
        lineStyle: {
          color: "#CBCBCB",
        },
      },
      axisLabel: {
        formatter: function (params) {
          var newParamsName = "";
          var paramsNameNumber = params.length;
          var provideNumber = 6;
          var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
          if (paramsNameNumber > provideNumber) {
            for (var p = 0; p < rowNumber; p++) {
              var tempStr = "";
              var start = p * provideNumber;
              var end = start + provideNumber;

              if (p == rowNumber - 1) {
                tempStr = params.substring(start, paramsNameNumber);
              } else {
                tempStr = params.substring(start, end) + "\n";
              }
              newParamsName += tempStr;
            }
          } else {
            newParamsName = params;
          }

          return newParamsName;
        },
        // interval: 0,
      },
      axisLine: {
        lineStyle: {
          color: "#CBCBCB",
        },
      },
      inverse: true,
      max: function (value) {
        if (value.max < 4) {
          value.max = 4;
        } else {
          value.max = value.max;
        }
        return value.max;
      },
    },
    dataZoom: [
      {
        type: "inside",
        startValue: 0,
        endValue: 4,
        yAxisIndex: [0],
        zoomOnMouseWheel: false, // 关闭滚轮缩放
        moveOnMouseWheel: true, // 开启滚轮平移
        moveOnMouseMove: true, // 鼠标移动能触发数据窗口平移
      },
    ],
    series: [
      {
        name: paramObj.name,
        data: paramObj.xData,
        type: "bar",
        barMaxWidth: 18, // 柱子宽度
        itemStyle: {
          color: function (params) {
            if (params.value >= 0) {
              return "#28CCCB";
            } else {
              return "#f7b500";
            }
          },
        },
      },
    ],
  };
  return option;
}
